<template>
    <div class="wrap">
      <div class="nav_bar">
        <van-icon
          name="arrow-left"
          size="20"
          style="position: absolute; left: 18px; top: 24px"
          @click="onClickLeft"
        />
        <span style="font-size: 20px; color: #323233; font-weight: bold">
            申请记录
        </span>
      </div>
      <div class="section">
        <div class="card" v-for="(item, index) in list" :key="index">
          <div class="cardBox">
            <div class="cardLeft">姓名</div>
            <div class="cardRight">{{ item.patientName }}</div>
          </div>
          <div class="cardBox">
            <div class="cardLeft">性别</div>
            <div class="cardRight">{{ item.patientSex }}</div>
          </div>
          <div class="cardBox">
            <div class="cardLeft">年龄</div>
            <div class="cardRight">{{ item.patientAge }}</div>
          </div>
          <div class="cardBox">
            <div class="cardLeft">状态</div>
            <div class="cardRight">{{ item.applyStatus }}</div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { surgeryList } from "@/api/surgery";
  import { getStore, setStore } from "@/utils/localStorage";
  export default {
    data() {
      return {
        list: [],
        current: 1,
        size: 10,
        show: true,
      };
    },
    component: {
      
    },
  
    created() {
      this.getList();
    },
    methods: {
      onClickLeft() {
        // this.$router.go(-1);
        this.$router.push({ path: "/menu" });
      },
      getList() {
        surgeryList().then((res) => {
          if (res.data.code == "200") {
            this.list = res.data.data.records;
          }
        });
      },
    },
  };
  </script>
 <style lang="less" scoped>
 .wrap {
   padding-top: 20px;
   .btn {
     width: 90%;
     height: 40px;
     margin: 0 auto 15px;
     background: #1578f9;
     font-size: 18px;
     border-radius: 23px 23px 23px 23px;
     font-weight: bold;
     color: #ffffff;
     text-align: center;
     line-height: 40px;
   }
   .nav_bar {
     text-align: center;
     color: #323233;
   }
 }
 .section{
    padding: 16px;
    box-sizing: border-box;
    .card{
      padding: 16px;
      box-sizing: border-box;
      background-color: #fff;
      border-radius: 10px;
      margin-bottom: 16px;
      .cardBox{
        display: flex;
        justify-content: space-between;
        padding-bottom: 16px;
        border-bottom: 1px solid #eee;
        margin-bottom: 16px;
        box-sizing: border-box;
        &:last-child{
          margin-bottom: 0;
          border-bottom: 0;
          padding-bottom: 0;
        }
        .cardLeft{
          width: 60px;
          color: #333;
        }
        .cardRight{
          width: calc(100% - 80px);
          color: #666;
        }
      }
    }
  }
</style>
  